/** 菜单 */
export default {
    home: "首页",
    systemMonitoring: "系统监控",
    systemTools: "系统工具", // 系统工具
    platformManage: "平台管理", // 平台管理
    workbench: "工作台", // 工作台
    organization: "组织架构", // 组织架构
    entityManage: "实体管理",
    enterpriseEquipment: "企业设备", // 企业设备
    systemManage: "系统管理", // 系统管理
        region: "行政区域", // 行政区域
        userManage: "账号管理", // 用户管理
        roleManage: "角色管理", // 角色管理
        deptManage: "部门管理", // 部门管理
        postManage: "岗位管理", // 岗位管理
        dictManage: "字典管理", // 字典管理
        counterManage: "计数器管理", // 计数器管理
        notice: "通知公告", // 通知公告
        i18nConfig: "国际化配置", // 国际化配置
    financeManage: "财务管理", // 财务管理
        applicationInfo: "应用信息", // 引用信息
        merchantInfo: "商户信息", // 商户信息
        payChannel: "支付渠道", // 支付渠道
        payPackage: "支付套餐", // 支付套餐
        payNotice: "支付通知", // 支付通知
        merchantNotice: "商户通知", // 商户通知
        payOrder: "支付订单", // 支付订单
        payOrderExtend: "支付订单扩展", // 支付订单扩展
        refundOrder: "退款订单", // 退款订单
    dataCorrection: "数据修正", // 数据修正
        equipmentData: "设备传输数据", // 设备传输数据
        minuteDimension: "分钟维度", // 五分钟维度
        hourDimension: "小时维度", // 小时维度
        hourShadowDimension: "小时影子维度", // 小时影子维度
        dayDimension: "天维度", // 天维度
    passengerFlow: "客流管理", // 客流管理
        screenSetting: "大屏设置", // 大屏设置
        passagewayManage: "出入口管理", // 出入口管理
        faceCaptureData: "人脸抓拍数据", //人脸抓拍数据
    logManage: "日志管理", // 日志管理
        operateLog: "操作日志", // 操作日志
        loginLog: '登录日志', // 登录日志
    developerCentre: "开发者", // 开发者
}